import styled from "styled-components";

const Index = styled.form``;

export default Index;
